type LogoProps = {
  className?: string;
};

// Brand wordmark from the mDenials portal.
export function Logo({ className }: LogoProps) {
  return <img src="/logo.svg" alt="mDenials" className={className} draggable={false} />;
}
